import { useEditor, useNode } from "@craftjs/core";
import { ReactNode } from "react";
import Settings from "./Settings";

interface ButtonContainerProps {
    columns?: number;
    children: ReactNode;
}

const PageButtonContainer = ({ columns = 2, children }: Partial<ButtonContainerProps>) => {
    const {
        connectors: { connect },
    } = useNode();

    const { enabled } = useEditor((state) => ({
        enabled: state.options.enabled,
    }));

    if (enabled && !children)
        return (
            <div ref={(ref) => connect(ref!)} className="w-full p-3 bg-gray-200 rounded animate-pulse">
                This is an empty button container, add a 'Button' component here.
            </div>
        );

    return (
        <div
            ref={(ref) => connect(ref!)}
            className="grid gap-6"
            style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
        >
            {children}
        </div>
    );
};

export default PageButtonContainer;

PageButtonContainer.craft = {
    displayName: "Container",
    props: {
        columns: 2,
    },
    related: {
        settings: Settings,
    },
    rules: {
        canDrag: () => false,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        canDrop: (targetNode: any) =>
            targetNode.data.name === "PageContentContainer" ||
            targetNode.data.name === "Grid" ||
            targetNode.data.name === "Div",
    },
};
